import React from 'react';

export default function Blog001() {
  return (
    <section>
        <article>
          <h2>1. 06-17-2023</h2>
          <h3>Starting the Website</h3>
          <p>
            Hi
            </p>
            <br /><br /><br /><br /><br />
        </article>
        <h4>Links</h4>
        <br />
        <ul>
          <li>
            <a
              href="https://ericpolley.github.io/Projects_landing_page/"
              title="My first 5 weeks of Coding"
              ><p><strong>My first 5 weeks of Coding Projects</strong></p></a
            >
          </li>
        </ul>
      </section>
   
  )
}
